// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Loader ────────────────────────────────────────────────────── */
.loader {
    width: 36px;
    height: 36px;
    border: 3px solid #e3f2fd;
    border-top: 3px solid #1976d2;
    border-radius: 50%;
    animation: spin 0.9s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* ─── Page Header ────────────────────────────────────────────────── */
.bulk-page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    flex-wrap: wrap;
    gap: 12px;
}

.main-heading {
    color: #1a1a1a;
    font-size: 22px;
    font-weight: 600;
    margin: 0 0 4px 0;
}

.bulk-page-subtitle {
    color: #6b7280;
    font-size: 13px;
    margin: 0;
}

/* ─── Tabs ───────────────────────────────────────────────────────── */
.bulk-tabs {
    display: flex;
    gap: 0;
    border-bottom: 2px solid #e0e0e0;
    margin-bottom: 28px;
}

.bulk-tab {
    padding: 10px 28px;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    margin-bottom: -2px;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s;
}

.bulk-tab:hover {
    color: #1976d2;
}

.bulk-tab--active {
    color: #1976d2;
    border-bottom-color: #1976d2;
}

/* ─── No-access message ──────────────────────────────────────────── */
.bulk-no-access {
    text-align: center;
    padding: 60px 20px;
    color: #6b7280;
    font-size: 15px;
}

/* ─── Centered single-column upload area ─────────────────────────── */
.bulk-upload-single {
    display: flex;
    justify-content: center;
}

/* ─── Shared card ────────────────────────────────────────────────── */
.bulk-card {
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 32px 36px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
    width: 100%;
    max-width: 680px;
}

.bulk-card-title {
    font-size: 17px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 6px 0;
}

.bulk-card-desc {
    font-size: 13px;
    color: #6b7280;
    margin: 0;
    line-height: 1.6;
}

/* ─── File upload zone spacing ───────────────────────────────────── */
.bulk-file-upload-area {
    margin: 22px 0 16px;
}

/* ─── File info chip ─────────────────────────────────────────────── */
.bulk-file-info {
    background: #f0f7ff;
    border: 1px solid #cce4ff;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 20px;
}

.bulk-file-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    font-size: 13px;
}

.bulk-file-info-row:not(:last-child) {
    border-bottom: 1px solid #dbeeff;
}

.bulk-file-info-label {
    font-weight: 600;
    color: #1a1a1a;
}

.bulk-file-info-value {
    color: #1a1a1a;
    word-break: break-all;
    text-align: right;
    max-width: 75%;
}

/* ─── Upload action row ──────────────────────────────────────────── */
.bulk-upload-action {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
}

.bulk-upload-action {
    align-items: center;
    gap: 12px;
}

.bulk-disabled-hint {
    font-size: 12px;
    color: #6b7280;
}

/* ─── Progress block ─────────────────────────────────────────────── */
.bulk-progress {
    margin-top: 20px;
    padding: 20px;
    background: #f0f7ff;
    border: 1px solid #cce4ff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* Initial spinner state (before first SSE event) */
.bulk-progress-initial {
    display: flex;
    align-items: center;
    gap: 14px;
}

.bulk-progress-text {
    color: #0052cc;
    font-weight: 500;
    font-size: 13px;
    margin: 0;
}

/* Header row: percentage + record count */
.bulk-progress-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.bulk-progress-pct {
    font-size: 22px;
    font-weight: 700;
    color: #1976d2;
    line-height: 1;
}

.bulk-progress-counts {
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
}

/* Track + fill bar */
.bulk-progress-bar-track {
    width: 100%;
    height: 10px;
    background: #dbeafe;
    border-radius: 5px;
    overflow: hidden;
}

.bulk-progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #1976d2, #42a5f5);
    border-radius: 5px;
    transition: width 0.4s ease;
    min-width: 0;
}

/* Success / error counters */
.bulk-progress-stats {
    display: flex;
    gap: 16px;
    font-size: 13px;
    font-weight: 600;
}

.bulk-progress-stat-ok {
    color: #16a34a;
}

.bulk-progress-stat-err {
    color: #dc2626;
}

/* ─── Summary Cards ──────────────────────────────────────────────── */
.bulk-summary-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

@media (max-width: 900px) {
    .bulk-summary-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 480px) {
    .bulk-summary-grid { grid-template-columns: 1fr; }
}

.bulk-summary-card {
    background: white;
    border-radius: 10px;
    padding: 20px 18px;
    border-left: 4px solid transparent;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    transition: transform 0.15s, box-shadow 0.15s;
}

.bulk-summary-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.bulk-summary-total   { border-left-color: #1976d2; }
.bulk-summary-valid   { border-left-color: #7c3aed; }
.bulk-summary-success { border-left-color: #16a34a; }
.bulk-summary-error   { border-left-color: #dc2626; }

.bulk-summary-value {
    font-size: 34px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 6px;
}

.bulk-summary-total   .bulk-summary-value { color: #1976d2; }
.bulk-summary-valid   .bulk-summary-value { color: #7c3aed; }
.bulk-summary-success .bulk-summary-value { color: #16a34a; }
.bulk-summary-error   .bulk-summary-value { color: #dc2626; }

.bulk-summary-label {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

/* ─── Results table wrapper ──────────────────────────────────────── */
.bulk-table-wrapper {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 24px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}

/* ─── Table header ───────────────────────────────────────────────── */
.bulk-table-wrapper mc-table::part(header-cell) {
    background: #f5f5f5;
    font-weight: 600;
    color: #333;
}

/* ─── Approval: extra summary tone ───────────────────────────────── */
.bulk-summary-skipped { border-left-color: #f59e0b; }
.bulk-summary-skipped .bulk-summary-value { color: #d97706; }

/* ─── Approval: sub navigation + segmented control ───────────────── */
.bulk-subnav {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;
}

.bulk-segment {
    display: inline-flex;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
}

.bulk-segment-btn {
    padding: 8px 20px;
    font-size: 13px;
    font-weight: 600;
    color: #6b7280;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.15s, background 0.15s;
}

.bulk-segment-btn:not(:last-child) {
    border-right: 1px solid #d1d5db;
}

.bulk-segment-btn:hover:not(:disabled) {
    color: #1976d2;
}

.bulk-segment-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.bulk-segment-btn--active {
    background: #1976d2;
    color: #ffffff;
}

.bulk-segment-btn--active:hover:not(:disabled) {
    color: #ffffff;
}

.bulk-module-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin: 20px 0 14px;
}

/* ─── Approval: rules ────────────────────────────────────────────── */
.bulk-rules {
    margin-top: 10px;
    font-size: 13px;
    color: #4b5563;
}

.bulk-rules summary {
    cursor: pointer;
    color: #1976d2;
    font-weight: 600;
}

.bulk-rules ul {
    margin: 8px 0 0;
    padding-left: 20px;
    line-height: 1.6;
}

.bulk-rules .bulk-reasons {
    margin: 6px 0 0;
    padding-left: 20px;
}

/* ─── Approval: alerts ───────────────────────────────────────────── */
.bulk-alert {
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 20px;
    font-size: 13px;
    line-height: 1.5;
}

.bulk-alert ul {
    margin: 6px 0 0;
    padding-left: 20px;
}

.bulk-alert--error {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #991b1b;
}

.bulk-alert--warning {
    background: #fffbeb;
    border: 1px solid #fde68a;
    color: #92400e;
}

/* ─── Approval: toolbars ─────────────────────────────────────────── */
.bulk-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

.bulk-toolbar-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
}

.bulk-table-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
}

.bulk-chips {
    display: flex;
    gap: 8px;
}

.bulk-chip {
    padding: 4px 14px;
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 999px;
    cursor: pointer;
}

.bulk-chip:hover {
    color: #1976d2;
    border-color: #1976d2;
}

.bulk-chip--active {
    background: #1976d2;
    border-color: #1976d2;
    color: #ffffff;
}

.bulk-chip--active:hover {
    color: #ffffff;
}

/* ─── Approval: table frame (matches results table) ──────────────── */
.bulk-table-frame {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.bulk-table-frame--scroll {
    height: 480px;
}

.bulk-table-scroll {
    flex: 1 1;
    min-height: 0;
    overflow-y: visible;
}

.bulk-table-frame--scroll .bulk-table-scroll {
    overflow-y: auto;
}

/* ─── Approval: processing extras ────────────────────────────────── */
.bulk-progress-stat-warn {
    color: #d97706;
}

.bulk-progress-current {
    font-size: 12px;
    color: #6b7280;
}

/* ─── Approval: status pills ─────────────────────────────────────── */
.bulk-pill {
    display: inline-block;
    padding: 2px 10px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 999px;
    white-space: nowrap;
}

.bulk-pill--ok      { background: #dcfce7; color: #166534; }
.bulk-pill--err     { background: #fee2e2; color: #991b1b; }
.bulk-pill--warn    { background: #fef3c7; color: #92400e; }
.bulk-pill--info    { background: #dbeafe; color: #1e40af; }
.bulk-pill--neutral { background: #f3f4f6; color: #374151; }

/* ─── Approval: history ──────────────────────────────────────────── */
.bulk-card--wide {
    max-width: none;
}

.bulk-filter-card {
    margin-bottom: 24px;
    padding: 20px 24px;
}

.bulk-filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 16px;
}

.bulk-filter-field {
    width: 200px;
}

.bulk-filter-reports {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
}

.bulk-filter-reports-label {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
}

.bulk-html-table-wrap {
    overflow-x: auto;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}

.bulk-html-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.bulk-html-table th {
    position: sticky;
    top: 0;
    background: #f5f5f5;
    color: #333;
    font-weight: 600;
    text-align: left;
    padding: 10px 12px;
    white-space: nowrap;
}

.bulk-html-table td {
    padding: 10px 12px;
    border-top: 1px solid #eeeeee;
    white-space: nowrap;
}

.bulk-html-table tbody tr:nth-child(even) {
    background: #fafafa;
}

.bulk-html-table .num {
    text-align: right;
}

.bulk-html-table td.wrap {
    white-space: normal;
    word-break: break-all;
    min-width: 140px;
}

.bulk-html-table td.actions .bulk-link-btn + .bulk-link-btn {
    margin-left: 12px;
}

.bulk-link-btn {
    background: none;
    border: none;
    padding: 0;
    font-size: 13px;
    font-weight: 600;
    color: #1976d2;
    cursor: pointer;
}

.bulk-link-btn:hover:not(:disabled) {
    text-decoration: underline;
}

.bulk-link-btn:disabled {
    color: #9ca3af;
    cursor: not-allowed;
}

.bulk-stale-hint {
    font-size: 11px;
    color: #92400e;
    margin-top: 2px;
}

.bulk-pager {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
}

.bulk-pager-info {
    font-size: 12px;
    color: #6b7280;
}

/* ─── Approval: confirmation dialog ──────────────────────────────── */
.bulk-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
}

.bulk-modal {
    background: #ffffff;
    border-radius: 10px;
    padding: 28px 32px;
    width: 100%;
    max-width: 480px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
}

.bulk-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
}

/* ─── Module toggle sits left-aligned inside the card ────────────── */
.bulk-module-row .bulk-segment {
    flex-shrink: 0;
}

/* ─── Responsive ─────────────────────────────────────────────────── */
@media (max-width: 768px) {
    .bulk-page-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .bulk-card {
        padding: 20px;
    }

    .main-heading {
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/BulkUpload/bulkupload.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,MAAM;IACN,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;AACvB;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB,qCAAqC,EAAE;AAChE;;AAEA;IACI,qBAAqB,0BAA0B,EAAE;AACrD;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,0BAA0B,EAAE;AACpD,wBAAwB,0BAA0B,EAAE;;AAEpD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,4CAA4C,cAAc,EAAE;AAC5D,4CAA4C,cAAc,EAAE;AAC5D,4CAA4C,cAAc,EAAE;AAC5D,4CAA4C,cAAc,EAAE;;AAE5D;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA,uEAAuE;AACvE;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA,uEAAuE;AACvE,wBAAwB,0BAA0B,EAAE;AACpD,4CAA4C,cAAc,EAAE;;AAE5D,uEAAuE;AACvE;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA,uEAAuE;AACvE;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D,uEAAuE;AACvE;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ─── Loader ────────────────────────────────────────────────────── */\n.loader {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #e3f2fd;\n    border-top: 3px solid #1976d2;\n    border-radius: 50%;\n    animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ─── Page Header ────────────────────────────────────────────────── */\n.bulk-page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 32px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #e0e0e0;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.main-heading {\n    color: #1a1a1a;\n    font-size: 22px;\n    font-weight: 600;\n    margin: 0 0 4px 0;\n}\n\n.bulk-page-subtitle {\n    color: #6b7280;\n    font-size: 13px;\n    margin: 0;\n}\n\n/* ─── Tabs ───────────────────────────────────────────────────────── */\n.bulk-tabs {\n    display: flex;\n    gap: 0;\n    border-bottom: 2px solid #e0e0e0;\n    margin-bottom: 28px;\n}\n\n.bulk-tab {\n    padding: 10px 28px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #6b7280;\n    background: none;\n    border: none;\n    border-bottom: 3px solid transparent;\n    margin-bottom: -2px;\n    cursor: pointer;\n    transition: color 0.15s, border-color 0.15s;\n}\n\n.bulk-tab:hover {\n    color: #1976d2;\n}\n\n.bulk-tab--active {\n    color: #1976d2;\n    border-bottom-color: #1976d2;\n}\n\n/* ─── No-access message ──────────────────────────────────────────── */\n.bulk-no-access {\n    text-align: center;\n    padding: 60px 20px;\n    color: #6b7280;\n    font-size: 15px;\n}\n\n/* ─── Centered single-column upload area ─────────────────────────── */\n.bulk-upload-single {\n    display: flex;\n    justify-content: center;\n}\n\n/* ─── Shared card ────────────────────────────────────────────────── */\n.bulk-card {\n    background: #ffffff;\n    border: 1px solid #e0e0e0;\n    border-radius: 10px;\n    padding: 32px 36px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n    width: 100%;\n    max-width: 680px;\n}\n\n.bulk-card-title {\n    font-size: 17px;\n    font-weight: 600;\n    color: #1a1a1a;\n    margin: 0 0 6px 0;\n}\n\n.bulk-card-desc {\n    font-size: 13px;\n    color: #6b7280;\n    margin: 0;\n    line-height: 1.6;\n}\n\n/* ─── File upload zone spacing ───────────────────────────────────── */\n.bulk-file-upload-area {\n    margin: 22px 0 16px;\n}\n\n/* ─── File info chip ─────────────────────────────────────────────── */\n.bulk-file-info {\n    background: #f0f7ff;\n    border: 1px solid #cce4ff;\n    border-radius: 8px;\n    padding: 12px 16px;\n    margin-bottom: 20px;\n}\n\n.bulk-file-info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 0;\n    font-size: 13px;\n}\n\n.bulk-file-info-row:not(:last-child) {\n    border-bottom: 1px solid #dbeeff;\n}\n\n.bulk-file-info-label {\n    font-weight: 600;\n    color: #1a1a1a;\n}\n\n.bulk-file-info-value {\n    color: #1a1a1a;\n    word-break: break-all;\n    text-align: right;\n    max-width: 75%;\n}\n\n/* ─── Upload action row ──────────────────────────────────────────── */\n.bulk-upload-action {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 8px;\n}\n\n.bulk-upload-action {\n    align-items: center;\n    gap: 12px;\n}\n\n.bulk-disabled-hint {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* ─── Progress block ─────────────────────────────────────────────── */\n.bulk-progress {\n    margin-top: 20px;\n    padding: 20px;\n    background: #f0f7ff;\n    border: 1px solid #cce4ff;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* Initial spinner state (before first SSE event) */\n.bulk-progress-initial {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.bulk-progress-text {\n    color: #0052cc;\n    font-weight: 500;\n    font-size: 13px;\n    margin: 0;\n}\n\n/* Header row: percentage + record count */\n.bulk-progress-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n.bulk-progress-pct {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1976d2;\n    line-height: 1;\n}\n\n.bulk-progress-counts {\n    font-size: 13px;\n    font-weight: 500;\n    color: #6b7280;\n}\n\n/* Track + fill bar */\n.bulk-progress-bar-track {\n    width: 100%;\n    height: 10px;\n    background: #dbeafe;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.bulk-progress-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #1976d2, #42a5f5);\n    border-radius: 5px;\n    transition: width 0.4s ease;\n    min-width: 0;\n}\n\n/* Success / error counters */\n.bulk-progress-stats {\n    display: flex;\n    gap: 16px;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.bulk-progress-stat-ok {\n    color: #16a34a;\n}\n\n.bulk-progress-stat-err {\n    color: #dc2626;\n}\n\n/* ─── Summary Cards ──────────────────────────────────────────────── */\n.bulk-summary-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n@media (max-width: 900px) {\n    .bulk-summary-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 480px) {\n    .bulk-summary-grid { grid-template-columns: 1fr; }\n}\n\n.bulk-summary-card {\n    background: white;\n    border-radius: 10px;\n    padding: 20px 18px;\n    border-left: 4px solid transparent;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n    transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.bulk-summary-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n}\n\n.bulk-summary-total   { border-left-color: #1976d2; }\n.bulk-summary-valid   { border-left-color: #7c3aed; }\n.bulk-summary-success { border-left-color: #16a34a; }\n.bulk-summary-error   { border-left-color: #dc2626; }\n\n.bulk-summary-value {\n    font-size: 34px;\n    font-weight: 700;\n    line-height: 1;\n    margin-bottom: 6px;\n}\n\n.bulk-summary-total   .bulk-summary-value { color: #1976d2; }\n.bulk-summary-valid   .bulk-summary-value { color: #7c3aed; }\n.bulk-summary-success .bulk-summary-value { color: #16a34a; }\n.bulk-summary-error   .bulk-summary-value { color: #dc2626; }\n\n.bulk-summary-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n/* ─── Results table wrapper ──────────────────────────────────────── */\n.bulk-table-wrapper {\n    background: white;\n    border: 1px solid #e0e0e0;\n    border-radius: 10px;\n    padding: 24px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);\n}\n\n/* ─── Table header ───────────────────────────────────────────────── */\n.bulk-table-wrapper mc-table::part(header-cell) {\n    background: #f5f5f5;\n    font-weight: 600;\n    color: #333;\n}\n\n/* ─── Approval: extra summary tone ───────────────────────────────── */\n.bulk-summary-skipped { border-left-color: #f59e0b; }\n.bulk-summary-skipped .bulk-summary-value { color: #d97706; }\n\n/* ─── Approval: sub navigation + segmented control ───────────────── */\n.bulk-subnav {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 24px;\n}\n\n.bulk-segment {\n    display: inline-flex;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #ffffff;\n}\n\n.bulk-segment-btn {\n    padding: 8px 20px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #6b7280;\n    background: none;\n    border: none;\n    cursor: pointer;\n    transition: color 0.15s, background 0.15s;\n}\n\n.bulk-segment-btn:not(:last-child) {\n    border-right: 1px solid #d1d5db;\n}\n\n.bulk-segment-btn:hover:not(:disabled) {\n    color: #1976d2;\n}\n\n.bulk-segment-btn:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.bulk-segment-btn--active {\n    background: #1976d2;\n    color: #ffffff;\n}\n\n.bulk-segment-btn--active:hover:not(:disabled) {\n    color: #ffffff;\n}\n\n.bulk-module-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin: 20px 0 14px;\n}\n\n/* ─── Approval: rules ────────────────────────────────────────────── */\n.bulk-rules {\n    margin-top: 10px;\n    font-size: 13px;\n    color: #4b5563;\n}\n\n.bulk-rules summary {\n    cursor: pointer;\n    color: #1976d2;\n    font-weight: 600;\n}\n\n.bulk-rules ul {\n    margin: 8px 0 0;\n    padding-left: 20px;\n    line-height: 1.6;\n}\n\n.bulk-rules .bulk-reasons {\n    margin: 6px 0 0;\n    padding-left: 20px;\n}\n\n/* ─── Approval: alerts ───────────────────────────────────────────── */\n.bulk-alert {\n    border-radius: 8px;\n    padding: 12px 16px;\n    margin-bottom: 20px;\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.bulk-alert ul {\n    margin: 6px 0 0;\n    padding-left: 20px;\n}\n\n.bulk-alert--error {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #991b1b;\n}\n\n.bulk-alert--warning {\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    color: #92400e;\n}\n\n/* ─── Approval: toolbars ─────────────────────────────────────────── */\n.bulk-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.bulk-toolbar-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n}\n\n.bulk-table-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.bulk-chips {\n    display: flex;\n    gap: 8px;\n}\n\n.bulk-chip {\n    padding: 4px 14px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n    background: #ffffff;\n    border: 1px solid #d1d5db;\n    border-radius: 999px;\n    cursor: pointer;\n}\n\n.bulk-chip:hover {\n    color: #1976d2;\n    border-color: #1976d2;\n}\n\n.bulk-chip--active {\n    background: #1976d2;\n    border-color: #1976d2;\n    color: #ffffff;\n}\n\n.bulk-chip--active:hover {\n    color: #ffffff;\n}\n\n/* ─── Approval: table frame (matches results table) ──────────────── */\n.bulk-table-frame {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.bulk-table-frame--scroll {\n    height: 480px;\n}\n\n.bulk-table-scroll {\n    flex: 1;\n    min-height: 0;\n    overflow-y: visible;\n}\n\n.bulk-table-frame--scroll .bulk-table-scroll {\n    overflow-y: auto;\n}\n\n/* ─── Approval: processing extras ────────────────────────────────── */\n.bulk-progress-stat-warn {\n    color: #d97706;\n}\n\n.bulk-progress-current {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* ─── Approval: status pills ─────────────────────────────────────── */\n.bulk-pill {\n    display: inline-block;\n    padding: 2px 10px;\n    font-size: 12px;\n    font-weight: 600;\n    border-radius: 999px;\n    white-space: nowrap;\n}\n\n.bulk-pill--ok      { background: #dcfce7; color: #166534; }\n.bulk-pill--err     { background: #fee2e2; color: #991b1b; }\n.bulk-pill--warn    { background: #fef3c7; color: #92400e; }\n.bulk-pill--info    { background: #dbeafe; color: #1e40af; }\n.bulk-pill--neutral { background: #f3f4f6; color: #374151; }\n\n/* ─── Approval: history ──────────────────────────────────────────── */\n.bulk-card--wide {\n    max-width: none;\n}\n\n.bulk-filter-card {\n    margin-bottom: 24px;\n    padding: 20px 24px;\n}\n\n.bulk-filter-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 16px;\n}\n\n.bulk-filter-field {\n    width: 200px;\n}\n\n.bulk-filter-reports {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px;\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid #e0e0e0;\n}\n\n.bulk-filter-reports-label {\n    font-size: 12px;\n    font-weight: 600;\n    color: #6b7280;\n}\n\n.bulk-html-table-wrap {\n    overflow-x: auto;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n}\n\n.bulk-html-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n}\n\n.bulk-html-table th {\n    position: sticky;\n    top: 0;\n    background: #f5f5f5;\n    color: #333;\n    font-weight: 600;\n    text-align: left;\n    padding: 10px 12px;\n    white-space: nowrap;\n}\n\n.bulk-html-table td {\n    padding: 10px 12px;\n    border-top: 1px solid #eeeeee;\n    white-space: nowrap;\n}\n\n.bulk-html-table tbody tr:nth-child(even) {\n    background: #fafafa;\n}\n\n.bulk-html-table .num {\n    text-align: right;\n}\n\n.bulk-html-table td.wrap {\n    white-space: normal;\n    word-break: break-all;\n    min-width: 140px;\n}\n\n.bulk-html-table td.actions .bulk-link-btn + .bulk-link-btn {\n    margin-left: 12px;\n}\n\n.bulk-link-btn {\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: #1976d2;\n    cursor: pointer;\n}\n\n.bulk-link-btn:hover:not(:disabled) {\n    text-decoration: underline;\n}\n\n.bulk-link-btn:disabled {\n    color: #9ca3af;\n    cursor: not-allowed;\n}\n\n.bulk-stale-hint {\n    font-size: 11px;\n    color: #92400e;\n    margin-top: 2px;\n}\n\n.bulk-pager {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 12px;\n    margin-top: 16px;\n}\n\n.bulk-pager-info {\n    font-size: 12px;\n    color: #6b7280;\n}\n\n/* ─── Approval: confirmation dialog ──────────────────────────────── */\n.bulk-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 16px;\n}\n\n.bulk-modal {\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 28px 32px;\n    width: 100%;\n    max-width: 480px;\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);\n}\n\n.bulk-modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 24px;\n}\n\n/* ─── Module toggle sits left-aligned inside the card ────────────── */\n.bulk-module-row .bulk-segment {\n    flex-shrink: 0;\n}\n\n/* ─── Responsive ─────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n    .bulk-page-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .bulk-card {\n        padding: 20px;\n    }\n\n    .main-heading {\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
